//pdfExport.js
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

/**
 * 导出 PDF
 * @param {HTMLElement} element - 要导出的 DOM 元素
 * @param {string} filename - 导出的文件名
 */
export async function exportPDF(element, filename) {
    return new Promise((resolve, reject) => {
        // PDF 导出逻辑...
        // 成功时调用 resolve()
        // 失败时调用 reject()
        try {
            html2canvas(element).then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF();
                const imgWidth = 190; // PDF 页面宽度
                const pageHeight = pdf.internal.pageSize.height;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                let heightLeft = imgHeight;

                let position = 0;

                pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                // 如果图片高度大于页面高度，则需要添加新页面
                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    pdf.addPage();
                    pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }

                pdf.save(filename); // 保存 PDF
                resolve();
            });
        } catch (error) {
            console.error('生成 PDF 时出错:', error);
            reject(new Error('生成 PDF 失败: ' + error.message));
        }
    });
}

export async function exportContentPDF(content, outFileName) {
    try {
        // 创建一个临时的 DOM 元素来承载内容
        const tempElement = document.createElement('div');
        tempElement.innerHTML = content;
        document.body.appendChild(tempElement);

        const canvas = await html2canvas(tempElement);
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgWidth = 190; // PDF 页面宽度
        const pageHeight = pdf.internal.pageSize.height;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;

        let position = 0;

        // 添加图片到 PDF
        pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        // 如果图片高度大于页面高度，则需要添加新页面
        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }
        pdf.save(outFileName); // 保存 PDF
        // 清理临时元素
        document.body.removeChild(tempElement);
    } catch (error) {
        console.error('生成 PDF 时出错:', error);
        throw new Error('PDF 生成失败');
    }
}